/**
   使用
     this.$lPrompt({
        type:'overall',  使用这个弹框传递这个type字段并且使用overall类型,原本有的弹框使用逻辑不变
        title:'闯关段位规则',  title:标题
        message: '武功晋级路线：分为4个大段位，分别是：新秀、少侠、大侠、掌门，其中新秀有2个小段位，少侠、大侠、掌门各有4个小段位； 文功晋级路线：分为4个大段位，分别是：书童、秀才、举人、进士，其中书童有5个小段位，秀才有4个小段位，举人有2个小段位，进士有3个小段位；武功晋级路线：分为4个大段位，分别是：新秀、少侠、大侠、掌门，其中新秀有2个小段位，少侠、大侠、掌门各有4个小段位； 文功晋级路线：分为4个大段位，分别是：书童、秀才、举人、进士，其中书童有5个小段位，秀才有4个小段位，举人有2个小段位，进士有3个小段位；',
      })


 */

<template>
  <div class="l-dialog-box" v-if="visible">
    <div class="l-dialog">
      <div class="l-dialog-title">
        <slot name="title"></slot>
      </div>
      <div class="l-dialog-content">
        <slot name="msg"></slot>
      </div>
      <div class="l-dialog-close" @click="onCancle">
        <img src="./images/l-overall-close.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "l-dialog",
  data() {
    return {
      visible: false,
    };
  },
  props: {
    // 弹框显示
    modelShow: {
      type: Boolean,
      default: true,
    },
    autoClose: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    modelShow(val) {
      this.visible = val;
      //自动关闭弹框
      if (this.modelShow && this.autoClose) {
        setTimeout(() => {
          this.onConfirm();
        }, 3000);
      }
    },
  },
  methods: {
    //取消事件--有特殊事件处理
    onCancle(val) {
      this.$emit("cancle", val);
    },
    //确认事件--有特殊事件处理
    onConfirm(val) {
      this.$emit("confirm", val);
    },
  },
};
</script>
<style lang="stylus" scoped>
.l-dialog-box
  position fixed
  background rgba(0, 0, 0, 0.75)
  top 0
  left 0
  bottom 0
  right 0
  z-index 2001
  animation dialogAnimation 0.2s
  .l-dialog
    width 700px
    height 547px
    padding 10px
    box-sizing border-box
    left 50%
    top 50%
    transform: translate(-50%,-50%)
    position relative
    display flex
    align-items center
    flex-flow column
    background url('./images/l-overall-bg.png?x-oss-process=image/interlace,1') no-repeat center
    background-size 100% !important
    animation dialogBoxAnimation 0.5s
  .l-dialog-close{
    img{
      width 25px
      position: absolute
      top 70px
      right 50px
      cursor pointer
    }
  }
  .l-dialog-content
    font-size 20px
    color #fff
    display flex
    flex-direction column
    align-items center
    width 75%
    box-sizing border-box
    min-height 128px
    max-height 280px
    overflow-y auto
    word-break break-word
    margin 130px auto 0
    padding: 10px
    
  .l-dialog-title
    width 330px;
    height 81px;
    background url('./images/l-overall-title.png?x-oss-process=image/interlace,1') no-repeat
    background-size 100% !important
    position: absolute;
    top 30px
    text-align: center;
    line-height: 65px;
    color #FFFFFF
    font-weight: 400;
    font-size: 24px;
    text-shadow: 0px 2px 0px #60656F;
  @keyframes dialogAnimation
    0%
      opacity 0
    100%
      opacity 1
  @keyframes dialogBoxAnimation
    0%
      max-width 10%
      max-height 10%
    100%
      max-width 100%
      max-height 100%
</style>
